export default {
    state: {
        projects: [],
    },
    mutations: {
        setProjects(state, projects) {
            state.projects = projects
        },
        addProject(state, project) {
            state.projects.push(project)
        },
        updateProject(state, project) {
            const index = state.projects.findIndex(item => item.id === project.id)
            Vue.set(state.projects, index, project)
        },
        addProjectLine(state, line) {
            const project = state.projects.findIndex(item => item.id === line.project_id)

            state.projects[project].lines.push(line)
        },
        updateProjectLine(state, line) {
            const project = state.projects.findIndex(item => item.id === line.project_id)
            const index = state.projects[project].lines.findIndex(item => item.id === line.id)

            Vue.set(state.projects[project].lines, index, line)
        },
        updateCCmails(state, { projectId, cc_emails }) {
            const index = state.projects.findIndex(item => item.id === projectId)
            Vue.set(state.projects[index].customer, 'cc_emails', cc_emails);
        },
        removeProjectLine(state, line) {
            const project = state.projects.findIndex(item => item.id === line.project_id)

            state.projects[project].lines = state.projects[project].lines.filter(item => item.id !== line.id)
        },
    },
    getters: {
        projects: state => state.projects,
        project: state => id => state.projects.find(item => item.id === id),
    },
    actions: {
        loadProjects(context) {
            window.axios.get('/api/projects')
                .then(({ data }) => {
                    context.commit('setProjects', data)
                })
                .catch(error => console.error(error))
        },
        loadProject(context, projectId) {
            window.axios.get(`/api/projects/${projectId}`)
                .then(({ data }) => {
                    context.commit('updateProject', data)
                })
                .catch(error => console.error(error))
        },
        addProject(context, payload) {
            context.commit('addProject', payload)
        },
        updateProject(context, payload) {
            context.commit('updateProject', payload)
        },
        addProjectLine(context, payload) {
            context.commit('addProjectLine', payload)
        },
        updateProjectLine(context, payload) {
            context.commit('updateProjectLine', payload)
        },
        removeProjectLine(context, payload) {
            context.commit('removeProjectLine', payload)
        },
        changeProjectAssignee(context, { projectId, assignee }) {
            return window.axios.put(`/api/projects/${projectId}`, {
                'user_id': assignee
            })
                .then(({ data }) => {
                    context.commit('updateProject', data)
                    context.dispatch('setSuccess', 'Sagen blev opdateret')
                })
                .catch(error => console.error(error))
        },
        changeProjectOverdueDate(context, { projectId, overdueDate }) {
            return window.axios.put(`/api/projects/${projectId}`, {
                'overdue_at': overdueDate
            })
                .then(({ data }) => {
                    context.commit('updateProject', data)
                    context.dispatch('setSuccess', 'Overdue dato blev opdateret')
                })
                .catch(error => console.error(error))
        },
        updateCCmails(context, { projectId, cc_emails, override_cc }) {
            if (override_cc) {
                context.commit('updateCCmails', { "projectId": projectId, "cc_emails": cc_emails })
                context.dispatch('setSuccess', 'CC emails blev opdateret')
            }
        }
    }
}
